module.exports = __webpack_public_path__ + "img/search.0aa33da1.svg";